export default {
  inject: {
    themeClass: {
      default: {}
    }
  }
}
